<div class="buy-sell-parent tw-py-8 lg:tw-py-20">
  @if (!tutorialContent) {
    <div class="container-fluid">
      <div class="tw-mx-auto tw-flex tw-max-w-full tw-items-center tw-justify-center">
        <div>
          <div class="tw-mx-auto tw-mb-16 tw-max-w-4xl tw-text-center">
            <p class="p-text-preheader">{{ 'howItWorksPage.tutorialHeader' | translate }}</p>
            <h3 class="p-text-h3 !tw-font-normal tw-text-[#1a1847]">
              {{ 'howItWorksPage.tutorialHeaderDesc' | translate }}
            </h3>
          </div>
        </div>
      </div>
      <div class="tw-mx-auto tw-max-w-full tw-text-center">
        <div
          (click)="setContent('buyer')"
          class="buy-sell-button tw-group tw-relative tw-mx-auto tw-mb-4 tw-h-[100px] tw-max-w-[280px] tw-flex-none tw-rounded-md tw-p-4 tw-text-left tw-shadow-[0_0_0px_2px_black] hover:tw-cursor-pointer hover:tw-bg-primary hover:tw-shadow-none hover:tw-drop-shadow-xl"
        >
          <div class="tw-relative tw-z-[1]">
            <strong class="tw-mb-2 tw-block tw-text-black group-hover:tw-text-white"
              [innerHTML]="'howItWorksPage.tutorialBuyerButton' | translate"
            ></strong>
            <p class="tw-text-[12px] tw-leading-normal tw-text-black group-hover:tw-text-white">
              {{ 'howItWorksPage.tutorialBuyerDesc' | translate }}
            </p>
          </div>
          <img
            src="/assets/img/icons/common/white-buy-bg.svg"
            alt="hand holding cash"
            class="tw-absolute -tw-top-[1px] tw-right-0 tw-w-[95px] tw-opacity-[15%]"
          />
        </div>
        <div
          (click)="setContent('seller')"
          class="buy-sell-button tw-group tw-relative tw-mx-auto tw-h-[100px] tw-max-w-[280px] tw-flex-none tw-rounded-md tw-p-4 tw-text-left tw-shadow-[0_0_0px_2px_black] tw-delay-75 hover:tw-cursor-pointer hover:tw-bg-primary hover:tw-shadow-none hover:tw-drop-shadow-xl"
        >
          <div class="tw-relative tw-z-[1]">
            <strong class="tw-mb-2 tw-block tw-text-black group-hover:tw-text-white"
              [innerHTML]="'howItWorksPage.tutorialSellerButton' | translate"
            ></strong>
            <p class="tw-text-[12px] tw-leading-normal tw-text-black group-hover:tw-text-white">
              {{ 'howItWorksPage.tutorialSellerDesc' | translate }}
            </p>
          </div>
          <img
            src="/assets/img/icons/common/white-sell-bg.svg"
            alt="hand presenting product"
            class="tw-absolute tw-right-0 tw-top-[3px] tw-w-[90px] tw-opacity-[15%]"
          />
        </div>
      </div>
    </div>
  }
  @if (tutorialContent == 'buyer') {
    <app-buy-sell-tutorial-content
      [content]="buyerSellerTutorial.buyer"
      [parentTutorialContent]="tutorialContent"
      class="tw-overflow-x-auto"
    ></app-buy-sell-tutorial-content>
  }
  @if (tutorialContent == 'seller') {
    <app-buy-sell-tutorial-content
      [content]="buyerSellerTutorial.seller"
      [type]="'seller'"
      [parentTutorialContent]="tutorialContent"
      class="tw-overflow-x-auto"
    ></app-buy-sell-tutorial-content>
  }
</div>
